/**
 * @generated SignedSource<<9bdf580e638457f6dd4242d42a79e405>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatPlus_influencer$data = {
  readonly email: string;
  readonly firstName: string | null;
  readonly id: string;
  readonly lastName: string | null;
  readonly phoneNumber: string | null;
  readonly " $fragmentType": "ChatPlus_influencer";
};
export type ChatPlus_influencer$key = {
  readonly " $data"?: ChatPlus_influencer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatPlus_influencer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatPlus_influencer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    }
  ],
  "type": "Influencer",
  "abstractKey": null
};

(node as any).hash = "3eed2b21d25ba75d8b95ab7b3bc12a3d";

export default node;
